import React, { useState } from 'react'

import CustomLink from '@ors/components/ui/Link/Link'

import { Button, Menu, MenuItem } from '@mui/material'
import { MdExpandMore } from 'react-icons/md'
import cx from 'classnames'

const ExpandableMenu = ({
  menu,
}: {
  menu: {
    title: string
    menuItems: {
      title: string
      url: string | null
      disabled?: boolean
      onClick?: () => void
    }[]
  }
}) => {
  const { title, menuItems } = menu

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {menuItems.length > 0 && (
        <Button
          className="h-10 cursor-pointer bg-white p-4 text-lg font-semibold uppercase tracking-[0.1em] text-typography-primary shadow-[0_4px_12px_0_rgba(0,0,0,0.25)] hover:bg-white hover:text-typography-primary"
          endIcon={
            <div className="rounded-full border border-solid border-black bg-[#ebff00]">
              <MdExpandMore size={16} color="black" />
            </div>
          }
          size="large"
          variant="contained"
          onClick={handleOpen}
        >
          {title}
        </Button>
      )}

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disablePortal
        keepMounted
        TransitionProps={{
          timeout: 0,
        }}
        MenuListProps={{ disablePadding: true }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            elevation: 4,
            sx: {
              borderRadius: '10px !important',
              mt: 1,
              minWidth: 200,
              boxShadow: '0px 2px 10px rgba(0,0,0,0.08)',
            },
          },
        }}
      >
        {menuItems.map(({ url, onClick, title, disabled }, index) => (
          <div
            key={`${index}-${index}`}
            className={cx({
              'border-0 border-b-[3px] border-solid border-b-[#62BAF2]':
                index !== menuItems.length - 1,
            })}
          >
            <MenuItem
              className="rounded-none p-0 hover:bg-mlfs-hlYellow"
              onClick={handleClose}
              disabled={disabled}
            >
              <CustomLink
                className="h-full w-full text-nowrap py-1.5 pl-3 pr-12 text-lg normal-case tracking-[0.05em] no-underline"
                variant="contained"
                onClick={onClick}
                href={url}
              >
                {title}
              </CustomLink>
            </MenuItem>
          </div>
        ))}
      </Menu>
    </>
  )
}

export default ExpandableMenu
